import reducer from "./reducers";

export { default as discountOperations } from "./operations";

export default reducer
